import { render, staticRenderFns } from "./BlogsForm.vue?vue&type=template&id=1c9a196e"
import script from "./BlogsForm.vue?vue&type=script&lang=js"
export * from "./BlogsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports